// Single kill-switch for the in-app subscription lockout wall. Flip to false to
// disable the gate app-wide (revert without touching the audit work).
export const SUBSCRIPTION_LOCKOUT_ENABLED = true

// Only the period end matters for the lapse test; accept any row shape that carries it
// (authStore's StoredSubscription, the /subscription page's SubRow — current_period_end
// may be null there). A null/absent period fails open.
type LapseInput = { current_period_end: string | null } | null | undefined

// The ONE definition of "this tenant's subscription has lapsed" for the in-app app.
// Owner decision: lock anything whose billing period has ENDED — expired trial AND
// lapsed paid alike — and leave open anything with a future current_period_end
// (in-progress trial, active-in-period, canceled-but-paid-through).
//
// FAIL-OPEN by construction: no subscription row, a null/unparseable date, or any
// read gap → false (never wall a paying customer on a read error).
//
// This is the same date-based instant the storefront uses: mig 302 mirrors
// subscriptions.current_period_end → tenants.plan_expires_at, so app + storefront agree.
export function isTenantLockedOut(sub: LapseInput): boolean {
  if (!sub || sub.current_period_end == null) return false
  const end = Date.parse(sub.current_period_end)
  if (!Number.isFinite(end)) return false
  return end <= Date.now()
}
